var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup34412(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    fill: "#262626",
    stroke: "#2D2D2D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.582 15.969L26.6862 19.0732L16.2216 29.5377C15.3645 30.3949 13.9747 30.3949 13.1175 29.5377C12.2603 28.6805 12.2603 27.2907 13.1175 26.4335L23.582 15.969Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.418 24.9424L17.8779 28.4023",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1178 14.0019L23.9714 15.6136C23.3696 15.9218 23.2408 16.7261 23.7164 17.2068L25.3637 18.8723C25.8556 19.3696 26.6931 19.2211 26.9841 18.585L28.4831 15.3079C28.8776 14.4454 27.962 13.5695 27.1178 14.0019Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 22.9175L28.4675 26.4045C28.858 26.795 28.858 27.4282 28.4675 27.8187L26.2992 29.9869C25.9087 30.3775 25.2755 30.3775 24.885 29.9869L21.398 26.4999",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4766 17.4128L15.9896 13.9258C15.599 13.5353 14.9659 13.5353 14.5754 13.9258L12.4071 16.0941C12.0166 16.4846 12.0166 17.1178 12.4071 17.5083L15.8941 20.9953",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup34412);
export default __webpack_public_path__ + "static/media/Group 34412.ba9d93a99e58299c58eeaf535e8d1d98.svg";
export { ForwardRef as ReactComponent };